import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { warehousePermissionUrl } from '.';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { IWarehouseUser } from '../warehousePermissionsInterfaces';
import { warehousePermissionsActions } from '../warehousePermissionsSlice';

function* fetchWarehousePermissionsSaga(action: ReturnType<typeof warehousePermissionsActions.fetchUsers>) {
  yield put(uiActionCreators.toggleLoading('warehouseUsers'));
  const response = yield* call(fetchLogisticsUsers, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(warehousePermissionsActions.setUsers(response.value));
  }

  yield put(uiActionCreators.toggleLoading('warehouseUsers'));
}

export function* watchFetchWarehousePermissions() {
  yield takeEvery(warehousePermissionsActions.fetchUsers.match, fetchWarehousePermissionsSaga);
}

export async function fetchLogisticsUsers(departmentId: number): Promise<IApiExecuteRespone<IWarehouseUser[]>> {
  return executeApiRequest(() => httpService.get(warehousePermissionUrl({ departmentId })));
}
